import React, { ChangeEvent, useEffect, useState } from 'react';
import SearchBar from '../../../../components/SearchBar';
import useUserProfile from '../../../../../customHooks/useUserProfile';
import { useZinantisMembers } from '../../../../contextsProperty/ContextZinantisMembers';
import Tooltip from '../../../../../muiComponents/Tooltip';
import IconButton from '../../../../../muiComponents/IconButton';
import TypeaheadCountries from './TypeaheadCountries';
import ConnectedFilter from './ConnectedFilter';

const MembersFiltersBar = () => {
    const { translate } = useUserProfile();
    const { filters, updateFilters, resetFilters } = useZinantisMembers();

    const [areFiltersVisible, setAreFiltersVisible] = useState(false);

    useEffect(() => {
        if (!areFiltersVisible) {
            resetFilters();
        }
    }, [areFiltersVisible]);

    return (
        <>
            <div className='flex gap-5 flex-align-start width100perc'>
                <div className='flex-column gap-5 flex-grow padding-top4'>
                    <SearchBar
                        placeholder={translate('search')}
                        value={filters.name}
                        onChange={(e: ChangeEvent<HTMLInputElement>) =>
                            updateFilters('name', e?.target.value || '')
                        }
                        onClear={() => updateFilters('name', '')}
                    />
                    {areFiltersVisible ? (
                        <div className='flex gap-10 flex-align-center'>
                            <TypeaheadCountries />
                            <ConnectedFilter />
                        </div>
                    ) : (
                        ''
                    )}
                </div>
                <Tooltip titleText={'show_filters'}>
                    <div>
                        <IconButton
                            iconName='Tune'
                            onClick={() => setAreFiltersVisible(prev => !prev)}
                        />
                    </div>
                </Tooltip>
            </div>
        </>
    );
};

export default MembersFiltersBar;
